import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Layout, Divider, Input, Icon, Row,
} from 'antd';
import { connect } from 'react-redux';
import ConfigHeading from '../../configure/components/ConfigHeading';
import { searchForTokenPurchase } from '../../../../state/ui/purchase/purchaseCreditsUiActions';
import { selectPurchaseSearchRequest } from '../../../../state/ui/purchase/purchaseCreditsUiReducer';
import '../bynx.css';
import PurchasesTable from '../../purchase/PurchasesTable';

const searchWaitMs = 800;
/**
 * Displays the user summary object to help the user remember whop they are talking to
 * @param {object} props.userDetails The user summary object to display
 */
function CurrentDetails({ userDetails }) {
  if (!userDetails) return <></>;

  return (
    <div className="credit-enquiry--user-details">
      <div className="user-result--keywords">
        <div>
          <span>
            <b>
              <FormattedMessage id="company" />
            </b>
            :&nbsp;
          </span>
          <span>
            {userDetails.companyName}
            ,&nbsp;
          </span>
          <span>{userDetails.displayAddress || <FormattedMessage id="noData" />}</span>
        </div>
      </div>
    </div>
  );
}

CurrentDetails.propTypes = {
  userDetails: PropTypes.shape({
    userId: PropTypes.number,
    username: PropTypes.string,
    displayName: PropTypes.string,
    companyName: PropTypes.string,
    displayAddress: PropTypes.string,
  }),
};
CurrentDetails.defaultProps = {
  userDetails: null,
};

/**
 * A component allowing a bynx admin user to look up a user and retrive the purchase history for their usergroup
 */
function TransactionSearch({
  isLoading, doSearch, purchases,
}) {
  const [currentValue, setCurrentValue] = useState('');
  const [searchTimeoutId, setSearchTimeoutId] = useState(null);
  // When the search string has been changed.
  const onChange = (value) => {
    setCurrentValue(value.target.value);
    if (searchTimeoutId) clearTimeout(searchTimeoutId);
  };

  useEffect(() => {
    // Wait a short moment after key press before searching.
    // moved this out of on change so that current value is up to date
    const timeoutId = setTimeout(() => {
      if (currentValue.length >= 5) doSearch(currentValue);
    }, searchWaitMs);
    setSearchTimeoutId(() => timeoutId);
  }, [currentValue, setSearchTimeoutId, doSearch]);

  return (
    <Layout className="via-layout-configure-main">
      <ConfigHeading
        titleId="transactionSearch"
        descriptionId="transactionSearchDesc"
      >
        <Row>
          MOBLYXI*
          <Input
            suffix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
            maxLength={45}
            value={currentValue}
            placeholder="e.g: cc0b270f-7a63-4f78-88cd-1879722c4441"
            onChange={onChange}
            style={{ width: '400px' }}
          />
        </Row>
        <CurrentDetails userDetails={purchases[0]} />
        <Divider />
        <PurchasesTable
          isLoading={isLoading}
          purchases={purchases}
          includeCompanyName
        />
      </ConfigHeading>
    </Layout>
  );
}

// Validate the prop type parameters.
TransactionSearch.propTypes = {
  isLoading: PropTypes.bool,
  doSearch: PropTypes.func.isRequired,
  purchases: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      purchaseDateTime: PropTypes.string.isRequired,
      packageTitle: PropTypes.string.isRequired,
      purchaseStatus: PropTypes.string.isRequired,
      currencyCode: PropTypes.string.isRequired,
      mainTokens: PropTypes.number.isRequired,
      extraTokens: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      tokensRemaining: PropTypes.number.isRequired,
      vatCharge: PropTypes.number,
      expiryDate: PropTypes.string,
    }),
  ),
};

TransactionSearch.defaultProps = {
  isLoading: false,
  purchases: [],
};

/**
 * A function for connecting redux state to the component props.
 */
const mapStateToProps = (state) => {
  const pageDataRequest = selectPurchaseSearchRequest(state);
  const payload = pageDataRequest ? pageDataRequest.payload : [];

  return {
    isLoading: pageDataRequest ? pageDataRequest.isLoading : false,
    purchases: payload || [],
  };
};

/**
 * A function for connecting redux action to the component props.
 */
const mapDispatchToProps = dispatch => ({
  doSearch: value => dispatch(searchForTokenPurchase(value)),
});

/**
 * Connect the redux state to our component.
 */
export default connect(mapStateToProps, mapDispatchToProps)(TransactionSearch);
